import React from "react";
import { Helmet } from "react-helmet";
import Config from "../Config.json";
import { Link } from "react-router-dom";

const Koszonjuk = () => {
  const TITLE = Config.SITE_TITLE + " | Köszönjük!";
  const DESC = "Sikeresen elküldte az üzenetet.";
  const CANONICAL = Config.SITE_DOMAIN + "/hu/koszonjuk";

  return (
    <main className="thankyou-page text-center p-5">
      <Helmet>
        <title>{TITLE}</title>
        <meta name="description" content={DESC} />
        <link rel="canonical" href={CANONICAL} />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <h1 className="mt-5">Köszönjük az üzenetét!</h1>
      <p className="mt-3">Hamarosan felvesszük Önnel a kapcsolatot.</p>
      <Link to="/" className="btn btn-Bosch-primary mt-4">
        Vissza a főoldalra
      </Link>
    </main>
  );
};

export default Koszonjuk;
